// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"03896e2f","343":"d30b06e2","875":"b37fad64"}[chunkId] + ".chunk.js";
};